(() => {
  const activateImage = (gallery, mediaId) => {
    const mediaItems = Array.from(gallery.querySelectorAll('[data-media-id]'));
    const activeMedia = mediaItems.find((media) => media.dataset.mediaId === mediaId);
    if (!activeMedia) return;

    mediaItems.forEach((media) => media.classList.toggle('is-active', media === activeMedia));
    gallery.querySelectorAll('[data-target] button').forEach((button) => {
      button.removeAttribute('aria-current');
    });
    gallery.querySelector(`[data-target="${mediaId}"] button`)?.setAttribute('aria-current', 'true');
  };

  const bindHoverThumbnails = () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('media-gallery[data-hover-thumbnails="true"]').forEach((gallery) => {
      if (gallery.dataset.hoverBound === 'true') return;
      gallery.dataset.hoverBound = 'true';

          gallery.querySelectorAll('[data-target]').forEach((thumbnail) => {
            const activateThumbnail = () => activateImage(gallery, thumbnail.dataset.target);
            thumbnail.addEventListener('pointerenter', activateThumbnail);
            thumbnail.addEventListener('mouseenter', activateThumbnail);
            thumbnail.addEventListener('mouseover', activateThumbnail);
            thumbnail.querySelector('button')?.addEventListener('focusin', () => {
              activateImage(gallery, thumbnail.dataset.target);
            });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHoverThumbnails, { once: true });
  } else {
    bindHoverThumbnails();
  }
})();
